module.exports = __webpack_public_path__ + "img/photo.074c99ee.svg";